module.exports = __webpack_public_path__ + "img/imagem-capa.71974f23.png";